import { AutoComplete, Button, Typography } from "@kitbird/core";
import { useMemo, useState } from "react";
import { ReactComponent as SearchIcon } from "../../../../../assets/icons/search.svg";
import DetailUserAccount from "../DetailUserAccount/DetailUserAccount";
import { IOptionItemAutoComplete } from "../../../../../typings/common";
import { IGetUserAccountResponse, IUserAccount } from "../../../../../services/userAccountService";
import { useDebounce } from "../../../../../hooks";
import { useGetUserAccountInactive } from "../../useUserAccount";

interface FormUserAccountProps {
  onSubmit: (values: IUserAccount | undefined) => void;
  onClose: () => void;
}

const initialUser = { label: "", value: "", checked: false };
const FormUserAccount = ({ onSubmit, onClose }: FormUserAccountProps) => {
  const [selectedUser, setSelectedUser] = useState<IOptionItemAutoComplete>(initialUser);
  const [inputValue, setInputValue] = useState("");
  const { data: allUser } = useGetUserAccountInactive(useDebounce(inputValue, 300));

  const onInputChange = (inputVal: string) => {
    setInputValue(inputVal);
    if (selectedUser) {
      setSelectedUser((prev) => (prev ? ({ ...prev, value: inputVal }) : initialUser));
    }
  };

  const allUserOptions = useMemo(() => (allUser ? allUser.user.map((usr: Omit<IGetUserAccountResponse, "client_name" | "position_info">) => ({
    label: usr.employee_id,
    value: usr.employee_id,
    labelOverridden: <Typography level={6} color="#444444">{usr.employee_id} &bull; {usr.employee_name}</Typography>,
  })) : []), [allUser]);

  const currentUser = useMemo(() => {
    if (!allUser) return null;
    return allUser.user.find((usr: Omit<IGetUserAccountResponse, "client_name" | "position_info">) => (selectedUser
      ? usr.employee_id === selectedUser.value
      : null));
  }, [selectedUser]);

  return (
    <form onSubmit={(ev) => {
      ev.preventDefault();
      onSubmit(currentUser);
    }}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "24px",
        }}
      >
        <AutoComplete
          autoFocus
          id="user-account-ac"
          label="NIP"
          value={selectedUser.value}
          onSelected={setSelectedUser}
          onInputChange={onInputChange}
          options={allUserOptions}
          onClear={() => setSelectedUser(initialUser)}
          notFoundContent={
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Typography level={7}>There are no data to display</Typography>
            </div>
          }
          name="user-account-ac"
          leftIcon={<SearchIcon />}
          dataTestId="user-account-ac-input"
        />
        {currentUser && (
          <DetailUserAccount
            userEmail={currentUser.employee_email}
            userName={currentUser.employee_name}
            userNip={currentUser.employee_id}
            showNip={false}
            isOnTable={false}
            showBg
          />
        )}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: "1rem",
            marginTop: ".75rem",
          }}
        >
          <Button variant="text" type="button" onClick={onClose}>
            Batal
          </Button>
          <Button disabled={!selectedUser || !currentUser} type="submit">Simpan</Button>
        </div>
      </div>
    </form>
  );
};

export default FormUserAccount;
